import api from "./api";

export function getAccommodationPage(country_id) {
  return api.get(`/accomationpage/${country_id}`);
}

export function createAccommodationPage(data) {
  return api.post("/accomationpage", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateAccommodationPage(country_id, data) {
  return api.put(`/accomationpage/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
